"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_expandable_section_1 = require("../expandable-section/awsui-expandable-section");
var FormSectionWrapper = /** @class */ (function (_super) {
    __extends(FormSectionWrapper, _super);
    function FormSectionWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormSectionWrapper.prototype.findExpandIcon = function () {
        var expandableSectionElement = this.find('awsui-expandable-section');
        if (expandableSectionElement) {
            return new awsui_expandable_section_1.default(expandableSectionElement.getElement()).findExpandIcon();
        }
        return null;
    };
    FormSectionWrapper.prototype.findHeader = function () {
        return this.find('[awsui-form-section-region="header"]');
    };
    FormSectionWrapper.prototype.findDescription = function () {
        return this.find('[awsui-form-section-region="description"]');
    };
    FormSectionWrapper.prototype.findContent = function () {
        return this.find('[awsui-form-section-region="content"]');
    };
    FormSectionWrapper.prototype.findFooter = function () {
        return this.find('[awsui-form-section-region="footer"]');
    };
    return FormSectionWrapper;
}(dom_1.ComponentWrapper));
exports.default = FormSectionWrapper;
//# sourceMappingURL=awsui-form-section.js.map